import React from "react";

import cn from "classnames";

import { boxForwardRef } from "../../../../../helpers/common/Box/Box";
import { Text } from "../../../../Text";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { OmitOfUnion } from "../../../../../types/react";
import type { TextProps } from "../../../../Text";

import classes from "./AvatarsViewText.styl";

const AVATARS_VIEW_TEXT_TEST_ID = "avatars-view-text-test-id";
type AvatarsViewTextProps = OmitOfUnion<
    TextProps,
    | "textCase"
    | "underline"
    | "strikethrough"
    | "alignmentX"
    | "width"
    | "lineHeight"
>;

const AvatarsViewText = boxForwardRef<
    BoxComponentWithDefault<"span", AvatarsViewTextProps, "className">
>(({ children, maxLines = 1, customVarsStyles, ...props }, ref) => (
    <Text
        data-tsid={AVATARS_VIEW_TEXT_TEST_ID}
        {...({ ...props, maxLines } as AvatarsViewTextProps)}
        customVarsStyles={cn(classes["custom-vars-styles"], customVarsStyles)}
        ref={ref}
    >
        {children}
    </Text>
));

AvatarsViewText.displayName = "AvatarsView.Text";

export default AvatarsViewText;
